import React from "react";
import Avatar from "../Avatar/Avatar";
import "./PlayerRow.css";

/**
 * Shared player row — used by the Players card on Game Home, the lobby
 * roster, the leaderboard, and the Control Room. Slot-driven so each
 * surface can vary trailing metadata.
 *
 * Props:
 *   player:   { id, displayName, avatarSrc?, score? }   required
 *   rank?:    number — when shown in a leaderboard context (renders left badge)
 *   trailing?: node — state-specific content (score, joined timestamp, chip)
 *   accent?:  "winner" | "host" | "none"   (default "none"; "winner" = gold)
 *   onClick?: row click handler (renders as <button>; otherwise <div>)
 */
const PlayerRow = ({
  player,
  rank,
  trailing,
  accent = "none",
  onClick,
  className = "",
  ...rest
}) => {
  const Tag = onClick ? "button" : "div";
  return (
    <Tag
      className={`gx-player-row gx-player-row--accent-${accent} ${onClick ? "is-interactive" : ""} ${className}`}
      onClick={onClick}
      {...rest}
    >
      {rank != null && <span className="gx-player-row-rank">{rank}</span>}
      <Avatar name={player?.displayName || ""} src={player?.avatarSrc} size="sm" />
      <span className="gx-player-row-name">{player?.displayName || "—"}</span>
      {trailing != null && <span className="gx-player-row-trailing">{trailing}</span>}
    </Tag>
  );
};

export default PlayerRow;
